(() => {
  if(window.tplPermanentPurchaseInit){window.tplPermanentPurchaseInit();return;}
  let observer;
  const init=()=>{
    observer?.disconnect();
    const bar=document.querySelector('[data-tpl-purchase-bar]');
    const ready=!!bar&&!!document.getElementById('TplPurchaseDialog');
    document.documentElement.classList.toggle('tpl-purchase-ready',ready);
    document.documentElement.classList.remove('tpl-purchase-docked');
    if(!ready){document.documentElement.style.setProperty('--tpl-purchase-height','0px');return;}
    bar.hidden=false;
    const measure=()=>document.documentElement.style.setProperty('--tpl-purchase-height',bar.offsetHeight+'px');
    observer=new ResizeObserver(measure);observer.observe(bar);measure();
  };
  window.tplPermanentPurchaseInit=init;
  document.addEventListener('shopify:section:load',init);document.addEventListener('tpl:product:changed',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
